import { GuardianLayout } from '@/components/layout/guardian'
import { useClientOnly } from '@/hooks/useClientOnly'
import Router from 'next/router'
import { use } from 'react'

export default function Home() {
  useClientOnly()

  use(Router.replace('/web/user-setting/'))
}

Home.getLayout = (page: React.ReactNode) => (
  <GuardianLayout>{page}</GuardianLayout>
)
